import { createComponent } from '@/common/util/templateHelpers';
import { App, Layout, Container, Block, Flex, IconFA, RouterLink } from '@/common/components';

import AppHeader from '@/components/AppHeader';
import AppFooter from '@/components/AppFooter';

import style from './index.module.scss';
import { faFacebook, faTiktok, faTwitter } from '@fortawesome/free-brands-svg-icons';

export default createComponent('BlogLayout', { style }, function BlogLayout ({ className, slots }, props) {
  return (
    <Layout className={className}>
      <div className='BlogLayout__Hero'>
        <App.Header>
          <AppHeader />
        </App.Header>
        <Container>
          <div className='BlogLayout__Header'>
            {slots.header}
          </div>
        </Container>
      </div>

      <App.Main>
        <Container>
          {slots.defaultSlot}

          <hr />

          <Block>
            <Flex container gap1 alignCenter justifyCenter>
              <Flex>
                <RouterLink href='https://www.facebook.com/AddictingGames'>
                  <IconFA large icon={faFacebook} />
                </RouterLink>
              </Flex>
              <Flex>
                <RouterLink href='https://twitter.com/AddictingGames'>
                  <IconFA large icon={faTwitter} />
                </RouterLink>
              </Flex>
              <Flex>
                <RouterLink href='https://www.tiktok.com/@addictinggames.com'>
                  <IconFA large icon={faTiktok} />
                </RouterLink>
              </Flex>
            </Flex>
          </Block>
        </Container>
      </App.Main>

      <App.Footer>
        <AppFooter />
      </App.Footer>
    </Layout>
  );
});
